<template>
  <div class="match-item-description">
    <h2>About {{ lender.title }}</h2>
    <p class="description-text">{{ lender.description }}</p>

    <div class="d-flex divider-container">
      <span>Lender Details</span>
      <hr />
    </div>

    <div class="loan-details-wrapper">
      <div>
        <h3>{{ loanInterestRateText }}</h3>
        <p class="subdued">Interest Rate</p>
      </div>
      <div>
        <h3>{{ loanPaymentTermsText }}</h3>
        <p class="subdued">Loan terms</p>
      </div>
      <div>
        <h3>{{ loanTypeText }}</h3>
        <p class="subdued">Loan Type</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DescriptionCard',
  props: {
    lender: Object,
    dealId: String,
  },
  computed: {
    loanInterestRateText () {
      if (this.lender.loanInterestRateCustomDescription) return this.lender.loanInterestRateCustomDescription

      const text = this.lender.loanInterestRate || this.lender.loan_interest_rate
      return text
        ? text + '%'
        : ''
    },
    loanPaymentTermsText () {
      if (this.lender.loanPaymentTermsCustomDescription) return this.lender.loanPaymentTermsCustomDescription

      return this.lender.loanPaymentTerms || this.lender.loan_payment_terms || ''
    },
    loanTypeText () {
      if (this.lender.loanTypeCustomDescription) return this.lender.loanTypeCustomDescription

      const type = this.lender.loanType
      if (!type) return 'No Preference'
      if (type === 'Conv') return 'Conventional Loan'

      return type
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  color: $textDarkMuted;
}

.loan-details-wrapper {
  width: 100%;
  max-width: 850px;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  text-align: center;

  @include md { flex-wrap: nowrap; }

  @include lg { padding-left: 10%; }

  div {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include md { padding: 20px 30px; }

    @include lg { padding: 20px 40px; }
  }

  h3 { color: $accentBlue; }

  p {
    margin-top: 10px;
    margin-bottom: 0;
    font-size: 14px;
    line-height: 16px;
  }
}

.description-text {
  font-family: "Avenir Book";
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 0;
  color: #4e4e4e;
  margin-top: 24px;
  margin-bottom: 24px;
}

.divider-container {
  color: #707070;
  font-weight: bold;
  font-size: 16px;
  font-family: "Sansation Bold", Serif;

  hr {
    flex-grow: 1;
    background-color: #C2F0F5;
    border: none;
    margin: 0.65em;
    margin-right: 0;

    height: 3px;
  }
}
</style>
